import { render, staticRenderFns } from "./micro-page.vue?vue&type=template&id=3da9ba68&scoped=true&"
import script from "./micro-page.vue?vue&type=script&lang=js&"
export * from "./micro-page.vue?vue&type=script&lang=js&"
import style0 from "./micro-page.vue?vue&type=style&index=0&id=3da9ba68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9ba68",
  null
  
)

export default component.exports